import styled from "styled-components";
import media from "constants/media";

export const Above = styled.div`
    position: relative;
    z-index: 3;

    margin-top: 0;

    ${media.mdUp`
        margin: -200px 0 130px;
    `}
`;

export const Background = styled.div`
    position: absolute;
    top: -100px;
    left: 50%;
    z-index: -1;

    width: 775px;
    height: 258px;

    background: url("/images/verkooppunten-letters.svg") no-repeat top center;

    transform: translateX(-50%);

    ${media.mdUp`
        top: -75px;

        width: 1660px;
        height: 540px;
        
        background-position: top center;
        background-size: cover;
    `}
`;
